import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { forwardRef, IconButton as ChakraIconButton, } from '@chakra-ui/react';
import { Spinner } from '../Spinner';
export const IconButton = forwardRef((props, ref) => {
    const iconSize = useMemo(() => {
        if (props.fontSize)
            return props.fontSize;
        if (props.size === 'lg')
            return '1.5rem';
        return '1.25rem';
    }, [props.fontSize, props.size]);
    return (_jsx(ChakraIconButton, { ref: ref, spinner: _jsx(Spinner, { fontSize: iconSize }), ...props, fontSize: iconSize }));
});
IconButton.displayName = 'IconButton';
